var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeMarkLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.151 6.66732C13.151 9.99598 9.50878 13.4627 8.28573 14.5333C8.17179 14.6202 8.0331 14.6672 7.89054 14.6672C7.74799 14.6672 7.60929 14.6202 7.49535 14.5333C6.27231 13.4627 2.63013 9.99598 2.63013 6.66732C2.63013 5.25283 3.18435 3.89628 4.17087 2.89608C5.15739 1.89589 6.49539 1.33398 7.89054 1.33398C9.28569 1.33398 10.6237 1.89589 11.6102 2.89608C12.5967 3.89628 13.151 5.25283 13.151 6.66732Z",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89062 8.66602C8.98009 8.66602 9.86328 7.77059 9.86328 6.66602C9.86328 5.56145 8.98009 4.66602 7.89062 4.66602C6.80116 4.66602 5.91797 5.56145 5.91797 6.66602C5.91797 7.77059 6.80116 8.66602 7.89062 8.66602Z",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeMarkLocation);
export default __webpack_public_path__ + "static/media/officeMarkLocation.54c13b45e932d2219fb309e34ef1179b.svg";
export { ForwardRef as ReactComponent };